export default __webpack_public_path__ + "static/media/revoked_icon.1a2b8ad6.svg";